import React from 'react';
import PropTypes from 'prop-types';

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import ManagedInput from 'components/form/managed_input';
import Tooltip from 'components/tooltip';

export const planCommissionCalculationModes = [
  'house_split',
  'use_custom_commission_amount',
  'use_plan_gross_commission',
  'use_plan_split_commission',
];

export default function PlanCohortInput({ allowCohorts, disabled, plan, tooltipSuffix, onChange }) {
  if (!allowCohorts || !planCommissionCalculationModes.includes(plan.realCalculationMode)) {
    // return null;
  }

  const tooltipContent = <span>
    When this option is selected, the broker's commission tier is determined by pooling all
    commissions paid under this commission plan <b>to any broker</b>.
    <br/>
    <br/>
    {tooltipSuffix}
  </span>;

  return (
    <ManagedInput
      disabled={disabled}
      name="forCohort"
      type="checkbox"
      value={plan.forCohort}
      onChange={onChange}
    >
      Pool commissions for all brokers on this plan
      <Tooltip
        content={tooltipContent}
        icon={faInfoCircle}
        iconClassName="text-muted ms-2"
      />
    </ManagedInput>
  );
}

PlanCohortInput.propTypes = {
  allowCohorts: PropTypes.bool,
  disabled: PropTypes.bool,
  plan: PropTypes.shape({
    forCohort: PropTypes.bool,
    realCalculationMode: PropTypes.string,
  }).isRequired,
  tooltipSuffix: PropTypes.node,
  onChange: PropTypes.func.isRequired,
};
